<template>
    <div class="email-template-staging-widget">
        <div class="widget-header">
            <h3>Confirm your template content</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div class="create-step">
                <email-template-composer
                    ref="composer"
                    :emailTemplateId="emailTemplateId"
                    :clientId="clientId"
                    :agencyId="agencyId" />
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button @click="addTemplate">Add</app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const EmailTemplateComposer = () => import('@/components/one-to-one-email/email-template-composer');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'email-template-staging-widget',

    props: ['options', 'widget'],

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'email-template-composer': EmailTemplateComposer,
        'loading-screen-svg': LoadingScreenSvg
    },

    data() {
        return {
            isInitializing: true,
            emailtemplateId: null,
            agencyId: null,
            clientId: null
        }
    },

    computed: {
        
    },

    methods: {
        addTemplate() {
            EventBus.$emit('email-template:select', {
                id: this.emailTemplateId,
                name: this.$refs.composer.name,
                subject: this.$refs.composer.subject,
                body: this.$refs.composer.body
            });
            
            this.closeWidget();
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        }
    },

    created() {
        this.emailTemplateId = this.options.emailTemplateId;
        this.agencyId = this.options.agencyId;
        this.clientId = this.options.clientId;
    }
}
</script>

<style>
.email-template-staging-widget.widget .content-wrapper {
    padding: 0;
}

.email-template-staging-widget .action-container {
    display: flex;
}

.email-template-staging-widget .action-container .btn {
    margin-left: 15px;
}

.email-template-staging-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.email-template-staging-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.email-template-staging-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}
</style>
